import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  viewChild,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@openng/optimus-ui/button';
import { DataView, DataViewModule } from '@openng/optimus-ui/dataview';
import { Facility } from 'src/app/model/locations/facility';

@Component({
  selector: 'app-contact-list-facilities',
  imports: [DataViewModule, TranslateModule, ButtonModule],
  templateUrl: './contact-list-facilities.component.html',
  styleUrl: './contact-list-facilities.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactListFacilitiesComponent {
  readonly facilities = input.required<Facility[]>();
  readonly canDelete = input.required<boolean>();
  readonly header = input.required<string>();

  readonly deleteContactListEvent = output<string>();
  readonly openFacilityEvent = output<Facility>();

  readonly dataView = viewChild.required<DataView>('dv');

  protected deleteContactListFromFacility(id: string): void {
    this.deleteContactListEvent.emit(id);
  }

  protected openFacility(facility: Facility): void {
    this.openFacilityEvent.emit(facility);
  }
}
